/* eslint-disable indent */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Formik } from 'formik';
import * as Yup from 'yup';
import {
  Box,
  Button,
  Modal,
  TextField,
  MenuItem,
  CircularProgress,
  makeStyles
} from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import firebase from 'firebase/app';

import 'firebase/functions';

const useStyles = makeStyles((theme) => ({
  root: {},
  importButton: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  modal: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  formControl: {
    minWidth: '100%'
  }
}));

const Toolbar = ({ className, refreshAdmins, ...rest }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formValidateError, setformValidateError] = useState();

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  async function addRole(type, email) {
    return firebase
      .functions()
      .httpsCallable('addAuthorizationRole-AddAuthorizationRole')({
      type,
      email
    });
  }

  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Box display="flex" justifyContent="flex-end">
        {/* <Button className={classes.importButton}>
          Import
        </Button>
        <Button className={classes.exportButton}>
          Export
        </Button> */}
        <Button
          color="primary"
          variant="contained"
          onClick={async () => {
            handleOpen();
          }}
        >
          Add User
        </Button>
      </Box>
      {/* <Box mt={3}>
        <Card>
          <CardContent>
            <Box maxWidth={500}>
              <TextField
                fullWidth
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SvgIcon fontSize="small" color="action">
                        <SearchIcon />
                      </SvgIcon>
                    </InputAdornment>
                  )
                }}
                placeholder="Search customer"
                variant="outlined"
              />
            </Box>
          </CardContent>
        </Card>
      </Box> */}
      <Modal
        disableBackdropClick={!!loading}
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.modal}>
          {formValidateError ? (
            <Box mb={2}>
              <Alert
                severity="error"
                onClose={() => setformValidateError(null)}
                className={classes.alert}
              >
                <AlertTitle>Error</AlertTitle>
                {formValidateError}
              </Alert>
            </Box>
          ) : null}
          <Formik
            initialValues={{
              email: '',
              role: 'admin'
            }}
            validationSchema={Yup.object().shape({
              email: Yup.string()
                .email('Must be a valid email')
                .max(255)
                .required('Email is required'),
              role: Yup.string().required('Role is required')
            })}
            onSubmit={async (values) => {
              setLoading(true);
              await addRole(values.role, values.email)
                .then(async () => {
                  const data = {
                    email: values.email,
                    role: values.role,
                    createDate: firebase.firestore.FieldValue.serverTimestamp(),
                    status: 'pending'
                  };

                  await firebase
                    .firestore()
                    .doc(`admins/${values.email}`)
                    .set(data)
                    .then(() => {
                      console.log('admin is created first time');
                      refreshAdmins();
                      setLoading(false);
                      setOpen(false);
                    })
                    .catch((e) => {
                      setformValidateError(
                        `User admin role given but there is an error while saving to DB. Code: ${e}`
                      );
                      setLoading(false);
                    });

                  // setLoading(false);
                })
                .catch((e) => {
                  console.log('ERROR', e);

                  setformValidateError(
                    'There is no user record corresponding to the provided identifier or user have some unverified information. Please contact with your developer team. Code:',
                    e.message
                  );
                  setLoading(false);
                });
            }}
          >
            {({
              errors,
              handleBlur,
              handleChange,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mb={2}>
                  <TextField
                    required
                    error={Boolean(touched.email && errors.email)}
                    fullWidth
                    helperText={touched.email && errors.email}
                    label="Email Address"
                    margin="normal"
                    name="email"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="email"
                    value={values.email}
                    variant="outlined"
                  />
                </Box>
                <Box mb={2}>
                  <TextField
                    select
                    required
                    error={Boolean(touched.role && errors.role)}
                    fullWidth
                    helperText={touched.role && errors.role}
                    label="Role"
                    margin="normal"
                    name="role"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    type="role"
                    value={values.role}
                    variant="outlined"
                  >
                    <MenuItem value="admin">Admin</MenuItem>
                  </TextField>
                </Box>
                <Button
                  color="primary"
                  disabled={isSubmitting}
                  fullWidth
                  size="large"
                  type="submit"
                  variant="contained"
                >
                  {isSubmitting ? <CircularProgress /> : 'Add'}
                </Button>
              </form>
            )}
          </Formik>
        </div>
      </Modal>
    </div>
  );
};

Toolbar.propTypes = {
  className: PropTypes.string,
  refreshAdmins: PropTypes.func
};

export default Toolbar;
